import React from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <div className="bg-black min-h-screen" data-id="element-0">
      <SalesPage data-id="element-1" />
    </div>;
}